import * as React from "react";
import { makeStyles, List, ListItem, ListItemText } from "@material-ui/core";
import {
  changeTheme,
  selectTheme,
  selectThemeColor,
} from "../../redux/portfolioSlice";
import { useDispatch, useSelector } from "react-redux";

export default function DarkModeSelectToggle() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const theme = useSelector(selectTheme);
  const themeColor = useSelector(selectThemeColor);

  const toggleTheme = () => {
    console.log("Theme color")
    dispatch(changeTheme());
  };

  return (
    <>
      <div style={themeColor}>
        <List className={classes.nav}>
          <ListItem
            className={classes.listItem}
            style={{ background: !theme ? "" : themeColor["--themeColor"] }}
            onClick={() => toggleTheme()}
          >
            <ListItemText className={classes.toggleText}>
              &#9789;
            </ListItemText>
          </ListItem>
          <ListItem
            className={classes.listItem}
            style={{ background: theme ? "" : themeColor["--themeColor"] }}
            onClick={() => toggleTheme()}
          >
            <ListItemText className={classes.toggleText}>
              &#9728;
            </ListItemText>
          </ListItem>
        </List>
      </div>
    </>
  );
}

const useStyles = makeStyles({
  nav: {
    display: "flex",
    paddingTop: 0,
    cursor: "pointer",
    paddingLeft: 16,
  },
  listItem: {
    color: "#ffffff",
    height: 24,
    width: 50,
  },
  toggleText: {
    fontSize: 10,
    color: "#ffffff",
    fontWeight: 400,
  },
});
